import React, { useEffect } from 'react'
import { motion, useTime } from 'framer-motion'
import TwoStepProgress from '../modals/TowStepPrgress'
import { GoChevronLeft } from 'react-icons/go'
import IranIcon from '../icons/iranIcon.png'
import inteNational from '../icons/international.png'
import { useState } from 'react'
import CustomInput from '../../../Modals/filter modal/Input'
import CargoService from '../../../services/Cargo'
import { data } from 'react-router'
import { IoIosArrowBack } from "react-icons/io";
import { useRef } from 'react'


export default function Step2({ type, 
    setCar,
    setProduct,
    setPrice,
    setDate,
    setWeight,
    setOriginCity,
    setOriginState,
    setDestCity,
    setDestState,
    errors,
    setDesc,
    setWeightType,
    weightType,

    refs,
   
    setType,currentStep = 1,
   
     setCurrentStep = () => {}, onSelectType = () => {}, images = {} }) {
  const { international = '/icon-512.png', domestic = '/icon-512.png' } = images

  const container = {
    hidden: { opacity: 0, y: 8 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.08,
        when: 'beforeChildren'
      }
    }
  }


   //origin and state dataa
  const [loading, setLoading] = useState(false);
const [Data, SetOriginData] = useState([]);

    async function getAllCityAndState() {
    try {
        setLoading(true);

        if(type==="domestic"){

          const res = await CargoService.getAllState();
          const states = res?.data?.data ?? [];
  
  
          const fetches = states.map((st) =>
          CargoService.getAllCity({ state_id: st._id })
              .then((r) => ({ state: st, citiesRes: r }))
              .catch((err) => {
              console.error("city fetch error for", st, err);
              return { state: st, citiesRes: null };
              })
          );
  
          const results = await Promise.all(fetches);
  
  
          const provincesWithCitiesArr = results.map(({ state, citiesRes }) => {
          const stateId = state?._id ?? state?.id ?? null;
          const stateName = state?.name ?? state?.title ?? String(stateId ?? "");
  
          const citiesArray = citiesRes?.data?.data ?? citiesRes?.data ?? citiesRes ?? [];
  
  
          const citiesNormalized = (Array.isArray(citiesArray) ? citiesArray : []).map((c) => {
              if (typeof c === "string") {
              return { name: c, value: c };
              }
              const cityId = c?._id ?? c?.id ?? c?.city_id ?? null;
              const cityName = c?.name ?? c?.title ?? c?.city_name ?? String(cityId ?? "");
              return { name: cityName, value: cityId ?? cityName };
          });
  
          return {
          
              label: stateName,   
              value: stateId,     
              subItems: citiesNormalized,
          };
          });
  
          SetOriginData(provincesWithCitiesArr);
        }else{


          const res = await CargoService.getAllCountry();
          const countries = res?.data?.data ?? [];
  
  
          const fetches = countries.map((st) => {
      
            
          
              return CargoService.getAllCity({ country_id: st?._id })
                .then((r) => ({ country: st, citiesRes: r }))
                .catch((err) => {
                  console.error("city fetch error for", st, err);
                  return { country: st, citiesRes: null };
                });
            
          });
  
          const results = await Promise.all(fetches);
          console.log(results)
  
          const provincesWithCitiesArr = results.map(({ country, citiesRes }) => {
          const stateId = country?._id ?? country?.id ?? null;
          const stateName = country?.name ?? country?.title ?? String(stateId ?? "");
  
          const citiesArray = citiesRes?.data?.data ?? citiesRes?.data ?? citiesRes ?? [];
  
  
          const citiesNormalized = (Array.isArray(citiesArray) ? citiesArray : []).map((c) => {
              if (typeof c === "string") {
              return { name: c, value: c };
              }
              const cityId = c?._id ?? c?.id ?? c?.city_id ?? null;
              const cityName = c?.name ?? c?.title ?? c?.city_name ?? String(cityId ?? "");
              return { name: cityName, value: cityId ?? cityName };
          });
  
          return {
          
              label: stateName,   
              value: stateId,     
              subItems: citiesNormalized,
          };
          });
  
          SetOriginData(provincesWithCitiesArr);

        }

    } catch (err) {
        console.error("getAllCityAndState error:", err);
        SetOriginData([]); 
    } finally {
        setLoading(false);
    }
    }
    useEffect(() => {
        getAllCityAndState();
        }, []);



    //car data
    const [carData,setCarData]=useState([])

    async function getAllCar(){
        try {   

            const res=await CargoService.getAllCarType()
            const ids=res?.data?.data?.map((it)=>{return  it._id})
            const name=res?.data?.data?.map((it)=>{return it?.label+"-"+it.name})

            

          
            setCarData(ids?.map((it,index)=>{return {value:it , label:name[index]} }))
            
        } catch (error) {
                console.log(error)
        }
    }
    useEffect(() => {
        getAllCar();
        }, []);

    const [productData,setProData]=useState([])

    async function getAllPro(){
        try {   

            const res=await CargoService.getAllProductType()
            const ids=res?.data?.data?.map((it)=>{return  it._id})
            const name=res?.data?.data?.map((it)=>{return it.name})

        
            setProData(ids?.map((it,index)=>{return {value:it , label:name[index]} }))
            
        } catch (error) {
                console.log(error)
        }
    }
    useEffect(() => {
        getAllPro();
        }, []);

      


  
  console.log(Data)


  const item = {
    hidden: { opacity: 0, y: 12 },
    show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: 'easeOut' } }
  }

  const [shake, setShake] = useState(false);

  return (
    <motion.section
      className="flex justify-start items-start flex-col gap-5 max-w-6xl w-full mx-auto"
      variants={container}
      initial="hidden"
      animate="show"
      dir="rtl"
    >

      <motion.div variants={item} className="flex flex-row justify-between w-full h-max">
        <img className="w-[80px] object-contain" src={international} alt="logo" />
        <div onClick={()=>{setCurrentStep(1)}} className="flex gap-1 cursor-pointer hover:scale-105 transition-all duration-200 text-special text-md">
            <p >بازگشت</p>
            <IoIosArrowBack className='text-special' strokeWidth={1} size={20} ></IoIosArrowBack>
        </div>
       
      </motion.div>

      <motion.p variants={item} className='block text-gray-400 text-[14px] lg:w-1/2 w-full leading-relaxed'>
        برای شروع نیاز به اطلاعاتی جهت ارائه خدمات بهتر برای ثبت بار به شما داریم. قابل توجه: تضمین حفظ اطلاعات شما با بارسرا می‌باشد.
      </motion.p>

      <motion.div variants={item} className="flex flex-row justify-start items-center gap-5 h-max w-full">
        <div className="h-[40px] w-[10px] rounded-lg bg-special" />
        <p className='text-gray-600 text-[18px]'>اطلاعات زیر را برای ثبت بار ثبت نمایید</p>
      </motion.div>

      {/* cards grid */}
      <motion.div variants={item} className="grid grid-cols-1 sm:flex sm:flex-wrap gap-8 w-full">

        <CustomInput 

        error={( errors.originCity)? "مبدا انتخاب کنید" : false}
        label="مبدا" items={Data} 
        setVal={setOriginState}
         setSubVal={setOriginCity} 
         type={"option"}></CustomInput>


        <CustomInput 
     
        error={( errors.destCity ) ? "مقصد انتخاب کنید" : false}
        label="مقصد" items={Data} setVal={setDestState} setSubVal={setDestCity} type={"option"} />

        
        <CustomInput
   
        error={errors.car ? " خودرو را انتخاب کنید" : false}
         label="خودرو" items={carData} setVal={setCar}  type={"option"}/>

        <CustomInput

        error={
          errors.product ? " کالا را وارد کنید" : false}
         label="کالاهای ارسالی"  
         setVal={setProduct}
         Placeholder="نام محصول خود را وارد کنید..."
         
           />
         
        <CustomInput
 
        error={errors.price ? "قیمت را وارد کنید" : false} label="قیمت" 
        items={Data} setVal={setPrice}
        type={"number"}/>


        <CustomInput
 
         error={errors.date ? "تاریخ نمیتواند خالی باشد" : false}
         label="تاریخ" items={Data} setVal={setDate}  type={"date"}/>

        <CustomInput
        error={errors.weightType ? "نوع تناژ را انتخاب کنید" : false}
         label="تناژ" 
         items={[{value:true,label:"آزاد"},{value:false,label:"تن"}]} 
         setVal={setWeightType}  
         type={"option"} 
         />
         {
          weightType===false &&
          <CustomInput

        error={errors.weight ? "وزن را وارد کنید" : false}
         label="وزن " 
         setVal={setWeight}  
         type={"number"} 
         unitLabel='تن' />
         }
        


        <CustomInput label="توضیح" items={Data} setVal={setDesc}  type={"text"} />

      </motion.div>


    </motion.section>
  )
}
